import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { CartProvider } from '@/context/CartContext';
import HomePage from '@/pages/HomePage';
import ProductsPage from '@/pages/ProductsPage';
import '@/App.css';

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <CartProvider>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/proizvodi/:category" element={<ProductsPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </CartProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
